export default {"src":"/_next/static/media/pillWithClock_64.5d440e62.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};